<template>
  <f7-page name="ko-detail" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>{{ pageTitle }}</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-block v-if="stationPollutants.length > 0" class="no-margin no-padding">
      <f7-list class="no-margin">
        <f7-list-item title="Znečisťujúca látka" smart-select :smart-select-params="{openIn: 'popover', closeOnSelect: true}">
          <select name="s_pollutant" v-model="selectedPollutantId">
            <option v-for="pollutant in stationPollutants" :value="pollutant.pollutant_id" :selected="pollutant.pollutant_id === selectedPollutantId" ><span class="fs-btn-ko" v-html="replacePollutantDesc(pollutant.pollutant_desc)"></span></option>
          </select>
        </f7-list-item>
      </f7-list>
    </f7-block>

    <template v-if="notEmptyObject(stationDataForChart)">
      <template v-if="emptyValueArray">
        <div class="error-msg" v-if="emptyValueArray">Údaje pre túto znečisťujúcu látku nie sú dostupné</div>
      </template>
      <template v-else>
        <highcharts ref="vtHighcharts" :updateArgs="[true, true, false]" :options="chartOptions"></highcharts>
      </template>

    </template>

  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';

import vtChart from './ko-detail-chart-options'

Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
  },
  global: {
    useUTC: true
  }
});


export default {
  components: {
    highcharts: Chart
  },
  data: function () {
    return {
      pageTitle: 'Aktuálne koncentrácie',
      stationIdForChart: null,
      stationMeta: {},
      stationDataForChart: {},
      stationExtraDataForChart: {},
      stationPollutants: [],
      selectedPollutantId: null,
      routedPollutantId: null,
      chartOptions: vtChart,
      emptyValueArray: false,
    };
  },
  watch: {
    stationDataForChart() {
      this.stationPollutants.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
      if (this.routedPollutantId === null) {
        this.selectedPollutantId = this.stationPollutants[0].pollutant_id;
      } else {
        this.selectedPollutantId = this.routedPollutantId;
      }
    },
    selectedPollutantId() {
      this.generateChart()
    }

  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-kvalita-ovzdusia');
    this.$f7.accordion.open('.shmu-i-kvalita-ovzdusia');
  },
  destroy() {
    clearInterval(this.tCheckInterval);
    this.stationIdForChart = null;
    this.stationDataForChart = {};
    this.stationExtraDataForChart = {};
  },
  methods: {
    onPageInit() {
      this.stationIdForChart = parseInt(this.$f7route.params.station_id);
      if (this.$f7route.params.pollutant_id) {
        this.routedPollutantId = this.$f7route.params.pollutant_id;
        if (this.routedPollutantId === 'pm10_dpr' || this.routedPollutantId === 'pm10_12h') {
          this.routedPollutantId = 't24001';
        }
      }
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (this.stationIdForChart && (isInit || (this.$moment().unix() - this.lastUpdated) > 60)) {
        this.loadHistoryData(this.stationIdForChart);
      } else {
        if (!this.stationIdForChart) {
          self.$f7.dialog.alert('Identifikátor stanice nebol správne určený!', 'Nastala chyba');
        }
      }
    },
    loadHistoryData(station_id) {
      const self = this;

      self.$f7.dialog.preloader('Načítavam...');
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getdata?station='+station_id+'&history=120&station_meta=1', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {

            if (!response.data.error && response.data[0]) {
              let r_data = response.data[0];
              self.stationMeta = r_data.station;
              self.pageTitle = self.stationMeta.station_name + ' - Aktuálne koncentrácie';
              self.stationPollutants = self.stationMeta.pollutants;
              self.stationDataForChart = r_data.data;
              self.stationExtraDataForChart = r_data.extra_data;
              self.lastUpdated = self.$moment().unix();
              // clearInterval(this.tCheckInterval);
              // this.tCheckInterval = setInterval(this.checkLastUpdated, 5 * 60 * 1000); // overujem kazdych 5 min
            } else {
              self.$f7.dialog.alert('Nepodarilo sa načítať údaje pre vykreslenie grafu', 'Nastala chyba');
            }
            self.$f7.dialog.close();
          }).catch((error) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      //  console.log(error);
      });

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) >= 2*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    replacePollutantDesc: function(desc) {
      switch (desc) {
        case 'PM10': return 'PM<sub>10</sub>';
        case 'PM2.5': return 'PM<sub>2.5</sub>';
        case 'NO2': return 'NO<sub>2</sub>';
        case 'NOX': return 'NO<sub>X</sub>';
        case 'O3': return 'O<sub>3</sub>';
        case 'SO2': return 'SO<sub>2</sub>';
        default: return desc;
      }
    },
    generateChart() {
      // console.log(e);
      const self = this;

      let measured = [];
      let dpr_pm10 = [];
      let pm10_12h = [];
      let vals = [];
      let dts = [];


      // priprav data pre chart
      if (this.stationDataForChart && this.stationDataForChart.length > 0) {

        let pollutantData = this.stationDataForChart.filter(obj => {
          return obj.pollutant_id === self.selectedPollutantId;
        })


        if (pollutantData && pollutantData.length > 0) {

          pollutantData.sort((a,b) => (a.dt > b.dt) ? 1 : ((b.dt > a.dt) ? -1 : 0));
          pollutantData.forEach((item) => {
            if (item.value === 'PDL') {
              item.value = null;
            }

            dts.push(item.dt);
            // donutenie ho zobrazovat SEC/LSEC casy na grafe
            let m_f = this.$moment.unix(item.dt).tz('Europe/Bratislava').utc().format();
            let m = this.$moment(m_f);
            let d = Date.UTC(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());

            //measured.push([item.dt * 1000, item.value]);
            measured.push([d, item.value]);

            if (item.value !== null) {
              vals.push(item.value);
            }

          });

          if (vals.length > 0) {
            this.emptyValueArray = false;
          } else {
            this.emptyValueArray = true;
          }


        } else {
          this.emptyValueArray = true;
        }
      }


      let max_value = 0;
      let min_value = 0;
      let min_dt = 0;

      if (dts.length > 0) {
        min_dt = Math.min.apply(null, dts);
      }


      // MIN MAX VALUES
      if (vals.length > 0) {
        min_value = Math.min.apply(null, vals);
        max_value = Math.max.apply(null, vals);

        if (max_value > 0) {
          max_value += Math.round((max_value * 0.2));
        } else {
          max_value += Math.round((Math.abs(max_value) * 0.2));
        }
        if (min_value < 0) {
          min_value -= Math.round((Math.abs(min_value) * 0.2));
        } else {
          min_value = 0;
        }
      }

      let max_value_check = 0;
      let minor_tick = 5;
      let normal_tick = 10;
      if (min_value < 0) max_value_check = Math.abs(min_value);
      else max_value_check = max_value;

      if (max_value_check > 500) { minor_tick = 50; normal_tick = 100; }
      else if (max_value_check > 200) { minor_tick = 10; normal_tick = 50; }
      else if (max_value_check > 50) { minor_tick = 5; normal_tick = 10; }
      else if (max_value_check > 0) { minor_tick = 1; normal_tick = 5; }

      this.chartOptions.yAxis[0].min = min_value;
      this.chartOptions.yAxis[0].max = max_value;
      this.chartOptions.yAxis[0].normalTick = normal_tick;
      this.chartOptions.yAxis[0].minorTick = minor_tick;

      //E:MIN MAX
      let pollutant = this.stationPollutants.find(obj => {
        return obj.pollutant_id === self.selectedPollutantId
      })


      // AK je vybrany PM10, rieime aj DPR PM10 a PM10-12H

      let dpr_pm10_serie = this.chartOptions.series.find(item => (item.id) === 'pm10_dpr');
      let pm10_12h_serie = this.chartOptions.series.find(item => (item.id) === 'pm10_12h');


      if (self.selectedPollutantId === 't24001') {
        let pollutantDataPM10_DPR = this.stationExtraDataForChart.filter(obj => {
          return obj.extra_pollutant_id === 'DPR_PM10';
        });

        let pollutantDataPM10_12H = this.stationExtraDataForChart.filter(obj => {
          return obj.extra_pollutant_id === 'PM10_12H';
        });

        //console.log(pollutantDataPM10_DPR, pollutantDataPM10_12H);

        pollutantDataPM10_DPR.sort((a,b) => (a.dt > b.dt) ? 1 : ((b.dt > a.dt) ? -1 : 0));
        pollutantDataPM10_DPR.forEach((item) => {
          if (item.value_avg === 'PDL') {
            item.value_avg = null;
          }
          if (item.dt < min_dt) return;

          // donutenie ho zobrazovat SEC/LSEC casy na grafe
          let m_f = this.$moment.unix(item.dt).tz('Europe/Bratislava').utc().format();
          let m = this.$moment(m_f);
          let d = Date.UTC(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());

          //dpr_pm10.push([item.dt * 1000, item.value_avg]);
          dpr_pm10.push([d, item.value_avg]);


        });

        pollutantDataPM10_12H.sort((a,b) => (a.dt > b.dt) ? 1 : ((b.dt > a.dt) ? -1 : 0));
        pollutantDataPM10_12H.forEach((item) => {
          if (item.value === 'PDL') {
            item.value = null;
          }

          // donutenie ho zobrazovat SEC/LSEC casy na grafe
          let m_f = this.$moment.unix(item.dt).tz('Europe/Bratislava').utc().format();
          let m = this.$moment(m_f);
          let d = Date.UTC(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());

          //pm10_12h.push([item.dt * 1000, item.value]);
          pm10_12h.push([d, item.value]);




        });

        dpr_pm10_serie.data = dpr_pm10;
        pm10_12h_serie.data = pm10_12h;
        this.chartOptions.legend.enabled = true;
        this.chartOptions.yAxis[0].plotLines = [
          {zIndex:5, value: 50, color: 'rgba(255, 255, 0, 0.8)', dashStyle: 'shortdash',
            width:2, label:{useHTML:true,style:{fontSize:'9px'},text:'50&micro;g/m<sup>3</sup>'}},
          {zIndex:5, value: 100, color: 'rgba(255, 100, 0, 0.8)', dashStyle: 'shortdash',
            width:2, label:{useHTML:true,style:{fontSize:'9px'},text:'100&micro;g/m<sup>3</sup>'}},
          {zIndex:5, value: 150, color: 'rgba(255, 0, 0, 0.8)', dashStyle: 'shortdash',
            width:2, label:{useHTML:true,style:{fontSize:'9px'},text:'150&micro;g/m<sup>3</sup>'}}
        ];


        // console.log(this.chartOptions);

      } else {
        dpr_pm10_serie.data = [];
        pm10_12h_serie.data = [];
        this.chartOptions.legend.enabled = false;
        this.chartOptions.yAxis[0].plotLines = [];

      }



      let m1 = this.chartOptions.series.find(item => (item.id) === 'm');
      m1.data = measured;

      if (pollutant.pollutant_id === 't85026') {
        m1.tooltip.valueSuffix = 'ng/m<sup>3</sup>';
      } else {
        m1.tooltip.valueSuffix = '&micro;g/m<sup>3</sup>';
      }
      m1.name = '1-h koncentrácia ' + this.replacePollutantDesc(pollutant.pollutant_desc);
      // this.chartOptions.yAxis[0].title.text =  this.replacePollutantDesc(pollutant.pollutant_desc) + '('+m1.tooltip.valueSuffix+')';
      this.chartOptions.title.text = self.stationMeta.station_name;
      this.chartOptions.subtitle.text = this.replacePollutantDesc(pollutant.pollutant_desc) + ' ('+m1.tooltip.valueSuffix+')';



    },


  }

};
</script>

<style lang="scss">

.error-msg {
  color: red;
  font-weight: bold;
  padding: 5px 10px;
  text-align:center;
}

.fs-btn-ko {
  font-size: 11px;

}
.btn-p {

}
</style>
